// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".import-upload[data-v-2c329a9f] {\n  width: 100%;\n}\n[data-v-2c329a9f] .import-upload .el-upload,[data-v-2c329a9f] .import-upload .el-upload-dragger {\n  width: 100%;\n}\n[data-v-2c329a9f] .import-dialog-form .el-form-item {\n  margin-bottom: 18px;\n}\n[data-v-2c329a9f] .import-dialog-form .el-radio {\n  margin-bottom: 8px;\n  line-height: 20px;\n}", ""]);
// Exports
module.exports = exports;
